import { EMAIL_RE } from './withEmailsClicaveis';

/**
 * Mesma regra de `withEmailsClicaveis`, para o bloco `html` (conteúdo migrado
 * que a carga ainda não converteu em texto do editor): cada e-mail em texto,
 * fora de um `<a>` e fora de atributos, vira `<a href="mailto:...">`.
 *
 * Tokenização simples por tags: o HTML é percorrido tag a tag; dentro de
 * `<a ...>...</a>` nada muda; comentários, `<script>` e `<style>` também são
 * pulados. Devolve a MESMA string quando não há nada a fazer.
 */
const TAG_RE = /<!--[\s\S]*?-->|<(\/?)([a-zA-Z][a-zA-Z0-9-]*)\b[^>]*>/g;
const SEM_TEXTO = new Set(['script', 'style', 'textarea']);

const escapaAtributo = (s: string) => s.replace(/"/g, '&quot;');

export function linkarTexto(texto: string): string {
  if (!texto.includes('@')) return texto;
  return texto.replace(
    EMAIL_RE,
    (email) => `<a href="mailto:${escapaAtributo(email)}">${email}</a>`,
  );
}

export function linkarEmailsHtml(html: string): string {
  if (!html || !html.includes('@')) return html;
  let saida = '';
  let pos = 0;
  let dentroDeLink = 0;
  let semTexto: string | null = null;
  let mudou = false;
  for (const m of html.matchAll(TAG_RE)) {
    const ini = m.index ?? 0;
    const trecho = html.slice(pos, ini);
    if (!dentroDeLink && !semTexto) {
      const novo = linkarTexto(trecho);
      if (novo !== trecho) mudou = true;
      saida += novo;
    } else {
      saida += trecho;
    }
    saida += m[0];
    pos = ini + m[0].length;
    if (m[0].startsWith('<!--')) continue;
    const fecha = m[1] === '/';
    const nome = (m[2] || '').toLowerCase();
    if (nome === 'a')
      dentroDeLink = Math.max(0, dentroDeLink + (fecha ? -1 : 1));
    if (SEM_TEXTO.has(nome)) semTexto = fecha ? null : nome;
  }
  const resto = html.slice(pos);
  if (!dentroDeLink && !semTexto) {
    const novo = linkarTexto(resto);
    if (novo !== resto) mudou = true;
    saida += novo;
  } else {
    saida += resto;
  }
  return mudou ? saida : html;
}

export default linkarEmailsHtml;
